import z from 'zod';

import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodAssociatedAccounts = z.array(
  z.object({
    id: z.number().int(),
    name: ZodTrimmedString,
    type: z.enum(['wm_personal', 'wm_business', 'b2b_admin']),
  }),
);
export type AssociatedAccounts = z.infer<typeof ZodAssociatedAccounts>;
